import { getFieldIcon } from "./getFieldIcon";

const createGroup = (id, items, heading = "") => ({ id, items, heading });
const createItem = (id, name, type, icon = "home") => ({ id, name, type, icon });
function getDefaultContainer() {
  return [
    createItem("container-1", "Section", "section", "check_box_outline_blank"),
    createItem("container-2", "Column", "column", "view_column"),
    createItem("container-3", "Block", "block", "grid_view")
  ];
}

export function getSidebarElementsForPositionRecordview() {
  return [
    {
      id: "group1",
      heading: "Containers",
      items: getDefaultContainer()
    },
    {
      id: "group2",
      heading: "Basic Fields",
      items: [
        createItem("basicfield-1", "Label", "label", getFieldIcon("label")),
        createItem("basicfield-2", "Icon", "icon", getFieldIcon("icon")),
        createItem("basicfield-3", "Image", "image", getFieldIcon("image")),
        createItem("basicfield-4", "Button", "button", getFieldIcon("button")),
        createItem("basicfield-5", "Dropdown", "dropdown", getFieldIcon("dropdown")),
        createItem("basicfield-6", "Field", "field", getFieldIcon("field")),
        createItem("basicfield-8", "Static Table", "table", getFieldIcon("table")),
        createItem("basicfield-9", "Separator", "separator", getFieldIcon("separator"))
      ]
    },
    {
      id: "group3",
      heading: "Table Fields",
      items: [
        createItem("tablefield-4", "Table", "rv_table", getFieldIcon("rv_table")),
        createItem("tablefield-13", "Map", "map", getFieldIcon("map")),
        createItem("tablefield-1", "Tile", "rv_tile", getFieldIcon("rv_tile")),
        createItem("tablefield-2", "Chart", "rv_chart", getFieldIcon("rv_chart")),
        createItem("tablefield-3", "Filters", "rv_filters", getFieldIcon("rv_filters")),
        createItem("tablefield-5", "Search", "search_box", getFieldIcon("search_box")),
        createItem("tablefield-6", "Columns Manager", "rv_columns_manager", getFieldIcon("rv_columns_manager")),
        createItem("tablefield-7", "File Downloader", "download_file", getFieldIcon("download_file")),
        createItem("tablefield-8", "Action Button", "rv_action_button", getFieldIcon("rv_action_button")),
        createItem("tablefield-9", "Action Dropdown", "rv_action_dropdown", getFieldIcon("rv_action_dropdown")),
        createItem(
          "tablefield-10",
          "Catalog Toggler",
          "rv_table_catalog_toggler",
          getFieldIcon("rv_table_catalog_toggler")
        ),
        createItem("tablefield-11", "List Of Actions", "rv_actions_list", getFieldIcon("rv_actions_list")),
        createItem("tablefield-12", "Tab Filter", "rv_tab_filters", getFieldIcon("rv_tab_filters"))
      ]
    }
  ];
}

export function getSidebarElementsForPositionPivot() {
  return [createGroup("group1", getDefaultContainer(), "Containers")];
}

export const chart_sidebar_elements = [
  {
    id: "group_containers",
    heading: "containers",
    items: [
      { id: "container_1", name: "section", type: "section", icon: "check_box_outline_blank" },
      { id: "container_2", name: "column", type: "column", icon: "view_column" },
      { id: "container_3", name: "block", type: "block", icon: "grid_view" }
    ]
  },
  {
    id: "chart_specific_fields",
    heading: "Chart Fields",
    items: [
      { id: "chartfield-1", name: "Tile", type: "chart_tile", icon: "looks_two" },
      { id: "chartfield-2", name: "Filters", type: "chart_filters", icon: "tune" }
    ]
  },
  {
    id: "group_2d_charts",
    heading: "charts",
    items: [
      { id: "chart_1", name: "line_chart", type: "chart", chart_type: "line", dimension: "2d", icon: "show_chart" },
      { id: "chart_2", name: "bar_chart", type: "chart", chart_type: "bar", dimension: "2d", icon: "bar_chart" },
      { id: "chart_3", name: "pie_chart", type: "chart", chart_type: "pie", dimension: "2d", icon: "pie_chart" },
      { id: "chart_4", name: "donut_chart", type: "chart", chart_type: "donut", dimension: "2d", icon: "donut_large" },
      { id: "chart_5", name: "table_chart", type: "chart", chart_type: "table", dimension: "2d", icon: "table_chart" }
    ]
  },
  {
    id: "group_3d_charts",
    heading: "stacked charts",
    items: [
      { id: "chart_6", name: "line_chart", type: "chart", chart_type: "line", dimension: "3d", icon: "show_chart" },
      { id: "chart_7", name: "bar_chart", type: "chart", chart_type: "bar", dimension: "3d", icon: "bar_chart" },
      { id: "chart_8", name: "table_chart", type: "chart", chart_type: "table", dimension: "3d", icon: "table_chart" }
    ]
  },
  {
    id: "group_spark_charts",
    heading: "spark charts",
    items: [
      {
        id: "chart_9",
        name: "spark_line",
        type: "chart",
        chart_type: "spark_line",
        dimension: "2d",
        icon: "show_chart"
      },
      {
        id: "chart_10",
        name: "spark_area",
        type: "chart",
        chart_type: "spark_area",
        dimension: "2d",
        icon: "area_chart"
      },
      { id: "chart_11", name: "spark_pie", type: "chart", chart_type: "spark_pie", dimension: "2d", icon: "pie_chart" },
      {
        id: "chart_12",
        name: "spark_column",
        type: "chart",
        chart_type: "spark_column",
        dimension: "2d",
        icon: "bar_chart"
      }
    ]
  },
  {
    id: "basic_fields",
    heading: "Basic Fields",
    items: [
      createItem("basicfield-1", "Label", "label", getFieldIcon("label")),
      createItem("basicfield-2", "Icon", "icon", getFieldIcon("icon")),
      createItem("basicfield-3", "Image", "image", getFieldIcon("image")),
      createItem("basicfield-7", "Separator", "separator", getFieldIcon("separator"))
    ]
  }
];

const createFieldForReactComponent = (components) => {
  return components.map((eachComponent) => {
    return createItem(eachComponent.id, eachComponent.name, "custom-component", "code");
  });
};

export function getSidebarElementsForPositionForm(reactComponents) {
  const reactComponentItems = createFieldForReactComponent(reactComponents || []);
  return [
    {
      id: "group1",
      heading: "Containers",
      items: getDefaultContainer()
    },
    {
      id: "group2",
      heading: "Basic Elements",
      items: [
        createItem("basic-1", "Spacer", "spacer", getFieldIcon("spacer")),
        createItem("basic-9", "Field", "field", getFieldIcon("field")),
        createItem("basic-2", "Label", "label", getFieldIcon("label")),
        createItem("basic-3", "Image", "image", getFieldIcon("image")),
        createItem("basic-4", "Tabview", "tabview", getFieldIcon("tabview")),
        createItem("basic-5", "Tableview", "tableview", getFieldIcon("tableview")),
        createItem("basic-6", "File Viewer", "file_viewer", getFieldIcon("file_viewer")),
        createItem("basic-7", "Separator", "separator", getFieldIcon("separator")),
        createItem("basic-8", "Icon", "icon", getFieldIcon("icon"))
      ]
    },
    // {
    //   id: "group3",
    //   heading: "Action Elements",
    //   items: [
    //     createItem("action-1", "Button", "button", getFieldIcon("button")),
    //     createItem("action-2", "Dropdown", "dropdown", getFieldIcon("dropdown")),
    //     createItem("action-3", "Button Group", "button-group", getFieldIcon("button-group"))
    //   ]
    // },
    {
      id: "group4",
      heading: "Custom Elements",
      items: [
        createItem("custom-1", "HTML", "html", getFieldIcon("html")),
        createItem("custom-2", "Dynamic-html", "dynamic-html", getFieldIcon("dynamic-html"))
      ]
    },
    {
      id: "group5",
      heading: "React Components",
      items: reactComponentItems
    }
  ];
}
